import { render, staticRenderFns } from "./SaldosBCRPage.vue?vue&type=template&id=63cf21df&scoped=true"
import script from "./SaldosBCRPage.vue?vue&type=script&lang=ts"
export * from "./SaldosBCRPage.vue?vue&type=script&lang=ts"
import style0 from "./SaldosBCRPage.vue?vue&type=style&index=0&id=63cf21df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf21df",
  null
  
)

export default component.exports